var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { CBRHeader, CBRHeaderWrapper, CardContainer } from '../eligibility/subcomponents';
import Icon from '../../icon';
import Eligible from '../eligibility/eligible';
import RequestRefundButton from '../../request-refund-button';
import StartChat from '../../start-chat';
var RequestRefundOnly = function (_a) {
    var eligibilityHeader = _a.eligibilityHeader, currentBalance = _a.currentBalance, isSetPay = _a.isSetPay, isBusinessError = _a.isBusinessError, icon = _a.icon, startExecution = _a.startExecution;
    var t = useTranslation().t;
    var header = t("header.applyCurrentBalance", {
        currentBalance: "-$".concat(currentBalance.slice(1)),
        optionText: t('header.theOptionText')
    });
    var subtextContent = isBusinessError ? (_jsx(StartChat, {})) : (t('subtext.receiveRefundCheck'));
    var buttonContent = !isBusinessError ? (_jsx(RequestRefundButton, { onClickHandler: startExecution })) : null;
    return (_jsxs(CardContainer, __assign({ hasMinHeight: !!isSetPay }, { children: [_jsx(CBRHeaderWrapper, { children: _jsx(CBRHeader, { children: header }) }), _jsx(Eligible, { icon: _jsx(Icon, { icon: icon, title: "refund check", size: "lg" }), header: eligibilityHeader, currentBalance: currentBalance, subtext: subtextContent, button: buttonContent })] })));
};
export default RequestRefundOnly;
